import { func, string } from "prop-types";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { emailRegex } from "@utils";
import { Button, ControlledTextField } from "@components";
import { CircularProgress } from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";

const activationFormSchema = (t) =>
  yup.object().shape({
    email: yup
      .string()
      .matches(emailRegex, t("errors.email.required"))
      .required(t("errors.email.required")),
    code: yup.string().required(t("errors.code.activate")).max(64),
  });

export const ActivationForm = ({ onSubmit, defaultEmail }) => {
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    setError,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(activationFormSchema(t)),
    defaultValues: {
      email: defaultEmail || "",
      code: "",
    },
  });

  const submitHandler = async (data) => {
    const result = await onSubmit(data);

    if (result) {
      const { errors } = result;

      errors?.forEach(({ field, message }) => {
        setError(field, { message });
      });
    }
  };

  return (
    <form
      autoComplete="on"
      aria-label="activation form"
      onSubmit={handleSubmit(submitHandler)}
    >
      <ControlledTextField
        name="email"
        control={control}
        label={t("forms.email")}
        autoComplete="email"
        type="email"
        disabled={!!defaultEmail}
        fullWidth
      />

      <ControlledTextField
        name="code"
        control={control}
        label={t("forms.code")}
        autoComplete="email"
        fullWidth
      />

      <Button
        isSubmit
        name="submit"
        variant="contained"
        fullWidth
        className="mt-6"
        icon={
          isSubmitting ? (
            <CircularProgress
              aria-label="progress indicator"
              size={24}
              color="inherit"
            />
          ) : undefined
        }
      >
        {!isSubmitting && t("routes.activate")}
      </Button>
    </form>
  );
};

ActivationForm.propTypes = {
  onSubmit: func.isRequired,
  defaultEmail: string,
};
